<ion-row>
  @for (filter of filters; track filter) {
    <ion-col size="6">
      @if (filter) {
        <ion-select interface="popover" [multiple]="true" [label]="filter.placeholder" label-placement="floating"
          fill="outline" type="radio" (ionDismiss)="searchOnChange($event, filter)"
          [interfaceOptions]="{cssClass: 'custom-ion-popover'}"
          class="custom-ion-popover ion-select-border-color-primary"
          style="white-space: initial; --color: var(--ion-color-primary)" mode="md">
          @for (option of filter.options; track option) {
            <ion-select-option [value]="option.value">{{option.name}}
            </ion-select-option>
          }
        </ion-select>
      }
    </ion-col>
  }
</ion-row>
